import { render, staticRenderFns } from "./RadioSwitch.vue?vue&type=template&id=1b385e1c"
import script from "./RadioSwitch.vue?vue&type=script&lang=ts"
export * from "./RadioSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports